import {Component, OnInit} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {ActivatedRoute} from "@angular/router";
import {convertTimestampToDate, Utility} from "../../../services/utils/utility";
import {Constants} from "src/app/services/utils/Constants";
import {GDOService} from "../../../services/gdo.service";
import {IGDOObject} from "../../models/hav-models";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../services/utils/state-management/store";

@Component({
  selector: "app-gdo-details",
  templateUrl: "./gdo-details.component.html",
  styleUrls: ["./gdo-details.component.css"]
})
export class GdoDetailsComponent implements OnInit {
  gdoId: string;
  errorMessage: string;
  name: string;
  ble: boolean;
  gdoDetails: IGDOObject;
  homeName: string;
  homeId: string;
  deviceName: string;
  KWIKSET_MODEL = "Kwikset®";
  WEISER_MODEL = "Weiser®";

  constructor(
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private gdoService: GDOService,
    private ngRedux: NgRedux<IAppState>
  ) {}

  ngOnInit() {
    Utility.focusLogo();
    this.activatedRoute.params.subscribe(
      params => (this.gdoId = params["id"])
    );
    this.getDeviceName(this.gdoId);
    this.getHomeName(this.homeId);
    this.getGDODetails(this.gdoId);
  }

  private getGDODetails(gdoId: string) {
    this.gdoService.getGdoDetails(gdoId).subscribe({
      next: (res) => {
        const data  = res["data"];
        this.gdoDetails = data;

        switch (this.gdoDetails.lcuHardwareRevision) {
          case "1":
            this.gdoDetails.lcuModel = 'LCU50';
            break;
          case "2":
            this.gdoDetails.lcuModel = 'LCU55';
            break;
          case "3":
            this.gdoDetails.lcuModel = 'LCU60';
            break;
          case "4":
            this.gdoDetails.lcuModel = 'LCU100';
            break;
          default:
            this.gdoDetails.lcuModel = 'LCU60'
        }
        let isKwikset = this.gdoDetails.brand.toLowerCase() === 'kwikset';
        if (this.gdoDetails.modelNumber.includes('800')) {
          this.gdoDetails.rcbModel = isKwikset ? `${this.KWIKSET_MODEL} Flex 800` : `${this.WEISER_MODEL} Flex 800`;
        } else if (this.gdoDetails.modelNumber.includes('1000')) {
          this.gdoDetails.rcbModel = isKwikset ? `${this.KWIKSET_MODEL} Flex 1000B` : `${this.WEISER_MODEL} Flex 1000B`;
        }

        isKwikset = this.gdoDetails.brand.toLowerCase() === 'kwikset';
        if (this.gdoDetails.modelNumber.includes('800')) {
          this.gdoDetails.rcbModel = isKwikset ? `${this.KWIKSET_MODEL} Flex 800` : `${this.WEISER_MODEL} Flex 800`;
        } else if (this.gdoDetails.modelNumber.includes('1000')) {
          this.gdoDetails.rcbModel = isKwikset ? `${this.KWIKSET_MODEL} Flex 1000B` : `${this.WEISER_MODEL} Flex 1000B`;
        }

        this.homeName = this.homeName || data.deviceName;
        this.deviceName = this.deviceName || data.deviceName;
      },
      error: (error: any) => {
        if ([Constants.ERROR_CODES.HOME_NOT_FOUND, Constants.ERROR_CODES.USER_NOT_AUTHORIZED].includes(error)) {
          this.errorMessage = this.translate.instant("GDO.INVALID_ACCESS");
        }
      }
    });
  }

  getHomeName(homeId: string) {
    const homes = this.ngRedux.getState().homes;
    const home = homes.find(h => h.homeId === homeId);
    this.homeName = home.homeName;
  }

  getDeviceName(gdoId: string) {
    const devices = this.ngRedux.getState().devices;
    Object.values(devices).forEach(deviceList => {
      const deviceArray = Array.isArray(deviceList) ? deviceList : Object.values(deviceList);
      const device = deviceArray.find(device => device.deviceId === gdoId && device.hasOwnProperty('manualMatterCode'));
      if (device) {
        this.deviceName = device.deviceName;
        this.homeId = device.homeId;
      }
    });
  }

  convertTimestampToDate(timestamp: number) {
    return convertTimestampToDate(timestamp);
  }

}
